export default {
  terms1:
    'BluePay 用户服务条款（以下简称“条款”）构成了 BluePay Company Limited（注册号：0105559091404），一家公司，依据泰国法律注册成立（以下简称“本公司”），与任何使用 BluePay 服务的用户（以下简称“用户”）之间的具有法律约束力的协议，用户已委托本公司提供服务（每一方为“一方”，合称“双方”）。',
  terms2:
    '本用户条款规定了本公司向用户提供支付服务（统称为“服务”）的条款，用于处理用户为购买商品、服务和/或数字内容（以下简称“商品与服务”）而支付的款项（以下简称“交易金额”）（“交易”）。',
  terms3:
    '如果服务由任何与 BluePay Company Limited 有关联的公司（以下简称“BluePay 关联方”）提供，则本条款应构成该 BluePay 关联方与用户之间的合同，并且 BluePay 关联方将负责根据本条款提供服务。“公司”或“我们”在本条款中的表述，应视为根据具体情况指代 BluePay Company Limited 或 BluePay 关联方。',
  terms4:
    '用户承认并同意，自用户提交申请使用服务之日起，遵守本条款，并同意在用户不同意本条款的任何部分时立即停止使用服务。通过使用或继续使用服务，用户接受并同意受本条款及其后续修订和修改的约束。',
  title_terms1: '1. 申请、审核及使用开始',
  terms5:
    '1.1 用户可以根据本公司不时制定的程序申请使用本公司提供的服务。通过申请使用本公司提供的服务，用户同意接受并遵守本条款以及本公司其他条款与政策。',
  terms6: '1.2 用户在申请使用提供的服务时，应向本公司提供本公司要求的所有必要信息。',
  terms7:
    '1.3 本公司可以要求用户提供其认为在申请使用服务时所需的进一步信息。用户在此保证并声明，向本公司提供的所有信息均为准确、完整和最新的。用户应立即通知本公司其所提供信息的任何变更。如果用户未能及时通知本公司其已提供信息的变更，或提供的信息不准确或不真实，则本公司可以拒绝该申请，暂停和/或终止向用户提供全部或部分服务，且无需进一步通知。用户应自行承担提交任何不正确、不真实或不完整信息，或延迟提交信息的后果。',
  terms8:
    '1.4 本公司拥有唯一的裁定权，决定是否批准用户提交的申请，以使用本公司的服务，并且没有义务向任何申请人披露审核过程。本公司不对申请人未通过审核过程而导致的任何损失或损害承担责任。',
  terms9:
    '1.5 用户将为其使用服务创建自己的账户（以下简称“服务账户”）和密码。用户在收到本公司批准其申请并创建服务账户后，可以开始使用该服务。',
  title_terms2: '2. 用户协议',
  terms10: '适用于所有用户：',
  terms11: '2.1 本公司应以合理的谨慎和专业技能提供服务，并遵守所有适用的法律和法规（包括本条款和隐私政策）。',
  terms12: '2.2 用户承认并同意，其仅有权使用服务来接收本公司事先批准并以书面通知用户的交易金额。',
  terms13:
    '2.3 用户承认并同意，用户与其他用户之间的任何权利和义务关系，涉及交易方式和条款，及交易的履行或不履行（包括但不限于拒绝履行、延迟、未交付、缺陷、错误、退货或更换商品与服务，及退款）仅存在于用户与其他用户之间。所有与此类交易相关的权利、义务和责任应由用户与其他用户依照适用法律法规及其协议条款自行履行和承担。本公司仅负责进行交易验证并根据适用的法律法规及本条款及其他适用条款向用户支付全部或部分交易金额。',
  terms14:
    '2.4 用户同意，本公司在提供服务时并非作为主体，而仅作为用户的协调方，帮助用户与其他用户达成交易。用户进一步同意允许本公司作为协调方接收并支付通过 BluePay 用户支付给用户的相关交易金额，并记录这些交易的账目。用户放弃对本公司提出任何索赔，无论是因本公司提供服务而导致的交易履行或不履行。',
  terms15:
    '2.5 用户应自行承担因（i）与其他用户之间的合同关系所产生的法律责任和义务，包括任何权利和责任、瑕疵担保及知识产权问题，及/或（ii）根据其他适用法律法规所产生的责任，包括但不限于《消费者保护法 B.E. 2522（1979）》（及修订版）。若因用户未履行上述法律责任和义务导致本公司遭受任何损失或损害，用户应立即并无条件地赔偿本公司，及/或为本公司提供赔偿并保持免责。',
  terms16:
    '2.6 本公司有权检查用户交易的商品与服务。如果需要，用户有义务向本公司提供相关商品与服务的详细信息，并说明其他相关事项（如额外费用、交付等），并确保所提交的支持付款请求的文件的正确性。',
  terms17:
    '2.7 如果用户（包括付款人和收款人）同意撤销、取消或终止任何交易，或在本公司已支付相关交易金额给收款人后更改所购买的商品和服务或交易价格，收款人和付款人应立即通知本公司相关撤销、取消、终止或变更交易的信息，并在本公司要求的退款期内提供退款单和相关支持文件。如果在退款期内未向本公司提供退款单，则收款人不得直接以现金方式向付款人退还商品与服务的价款。',
  terms18: '2.8 用户应与本公司共同防止非法、可疑或欺诈性交易，并配合公司处理相关事务。',
  terms19: '适用于法人用户：',
  terms20:
    '2.9 用户同意配合本公司，并允许本公司或其代表或代理人进入其场所进行审计（包括但不限于交易记录检查、交易异常或国家信用局所保留的信用记录等），以及其他相关事项。用户还同意，本公司及其渠道合作伙伴（如适用）有权对用户场所的信息进行必要的审计，以确保交易信息的安全。',
  terms21:
    '2.10 用户应根据公司规定的商品与服务类型，在用户的平台上向客户提供商品与服务，以便让客户通过用户平台发送购买订单和/或申请服务，并根据本条款规定的方式为商品与服务付款。在此过程中，用户应自行承担费用并提供以下信息并保留相关证据：',
  terms22: '2.10.1 用户商品与服务的描述，包括商品与服务的特点、质量和促销活动（如有）；',
  terms23: '2.10.2 商品与服务的退换或取消政策，包括对客户的退款；',
  terms24: '2.10.3 用户的营业地点，包括联系电话、传真号和/或电子邮件地址，供客户联系；',
  terms25: '2.10.4 商品与服务的价格，以泰铢或其他外币（如适用）表示；',
  terms26:
    '2.10.5 商品与服务的交付或履行的详细信息、流程、方法和交付期，以及客户的接受过程，包括但不限于境内外交付安排；',
  terms27: '2.10.6 用户的隐私政策和安全政策以及提供服务的网站。',
  terms28:
    '2.11 用户应负责根据广告或平台上商品与服务的详情向客户交付商品与服务。根据交易交付商品与服务应包括寻找商品与服务的来源、选择和检查商品与服务的质量、向制造商下订单、进口、进行海关程序、支付税费、运费和邮费、退换货、采购保险，包括设备和其他设施，以促进服务的提供及其他与商品与服务销售相关的职责（如适用）。',
  terms29: '2.12 用户应按照广告或平台上列明的标准包装商品与服务，或按照用户指定的方式交付：',
  terms30:
    '2.12.1 在销售商品的情况下，商品应处于良好状态，无任何缺陷。交付商品给客户时，用户应获得收货人签署的收货凭证或其他交付证明。用户应保存该收货凭证或证明至少7年，并在本公司要求时立即提交该证明；或',
  terms31: '2.12.2 在为客户提供服务的情况下，用户应提供高质量的服务，并符合广告材料、平台信息或其他用户规定的标准。',
  terms32:
    '2.12.3 若用户未能按照广告或平台信息交付商品与服务，且用户有合理理由或支持文件，用户应通知客户取消交易，并按照本条款规定的流程办理。',
  terms33:
    '2.13 用户应要求客户提供其姓名、地址及其他本公司规定的详细信息，并准备包含本公司提前通知的详细信息的电子数据形式的交易记录（“交易记录”）。该交易记录应通过互联网或任何电子方式提交给本公司，并按照公司提前通知用户的流程进行。用户进一步确认并同意，交易记录应通过用户的平台生成，且用户应在泰国注册为经营实体。本公司可以指定本条款中未规定的其他交易记录接收方式，并提前通知用户。用户同意按照本段规定的形式和提交方式保存交易记录，并不得向任何人披露。用户应对未履行本段义务所产生的对本公司和/或第三方的任何损害负责。',
  terms34: '2.14 关于交易，用户应始终在交付商品和服务之前，获得客户账户的扣款批准或授权，无论交易金额多少。',
  terms35:
    '2.15 用户应以公司规定的格式和方式总结交易记录，并在收到相关交易授权后的7天内提交给公司进行结算。用户承认，公司不负有核实交易记录摘要内容是否正确的义务，且用户同意，公司接收的交易记录内容视为准确无误，供公司根据本用户条款继续处理。',
  title_terms3: '3. 交易记录的保管',
  terms36: '3.1 用户承认并同意，如果用户未保留与任何交易相关的文件，则本公司保存的相关交易记录应视为真实和准确的。',
  terms37:
    '3.2 如果用户为法人，则用户与其客户之间的交易文件（包括关于该交易的电子信息记录、交易授权码和交易编号）及相关的收据和凭证应保存至少5年。如果在此期间发生任何争议，本公司可随时要求用户提供相关信息以供验证。如果用户未能在本公司要求后的七天内提供关于交易的文件以供验证，用户应将本公司已支付给用户的交易金额退还给本公司，或本公司可以从应支付给用户的其他款项中抵扣该金额。',
  title_terms4: '4. 账户信息与付款程序',
  terms38:
    '4.1 交易金额应由本公司存入独立的银行账户，并与本公司自身的运营资金分开管理。当本公司与用户之间约定的付款条件得到满足时，本公司应将用户应收的交易金额支付到用户所提供的有效银行账户，该账户应根据第9条的要求由用户在申请使用服务时提供，扣除本公司应收的各项费用后进行支付。',
  terms39:
    '4.2 与服务相关的所有费用，包括但不限于支付给用户的交易金额，应由用户支付或承担，无论该交易是否被撤销、取消或终止。为避免疑义，本公司在任何情况下均不向用户退还或归还此类费用。',
  terms40:
    '4.3 用户应对其服务账户的相关行为负责。服务账户不得转让、赠与或继承。如果用户决定不与本公司续约，应向本公司申请注销其服务账户。',
  terms41:
    '4.4 如果本公司有合理理由相信用户可能或将会破产，或正在进行清算、解散、破产、接管、管理或解散（或在任何司法管辖区发生类似情况），且/或本公司收到法院或其他主管机关或客户关于交易金额支付争议的通知，本公司有权暂停支付用户的交易金额，直到问题解决。',
  terms42:
    '4.5 本公司将记录用户所有使用服务的操作，无论该操作是否有效。用户可以通过本公司提供的管理界面查询其服务账户下的交易记录。如果用户发现任何错误记录，可以请求本公司提供相关的收款或付款指令记录。用户理解并同意，在本公司根据用户的指令将指定金额支付到用户的银行账户，并且本公司合作的金融机构确认已正确接收该金额后，本公司应视为已履行其在本条款下的付款义务。如果用户对付款有任何疑问，应向其银行账户所在的金融机构咨询。',
  title_terms5: '5. 用户的退款责任',
  terms43:
    '5.1 用户同意，在以下任一情形下，应退还本公司支付给其的款项，以免本公司遭受损失，并且本公司可以在以下情况下从应支付给用户的其他款项中扣除应退还的金额：',
  terms44: '5.1.1 交易被付款人拒付或提出赔偿要求。',
  terms45: '5.1.2 用户违反了本条款，或金融机构通知本公司，用户的交易存在风险、违法、可疑或违反适用法律或法规。',
  terms46: '5.1.3 用户为其他商户或个人进行交易，或通过非本公司提供的服务方式与本公司进行结算并请求付款。',
  terms47:
    '5.1.4 用户提交给本公司处理并结算的交易是由于用户从事其法律注册业务范围之外的业务，或从事未通知本公司的业务。',
  terms48: '5.1.5 本公司要求用户提供与交易相关的记录以供审核，但用户未能在收到本公司通知后的七天内提供相关记录。',
  title_terms6: '6. 公平对待',
  terms49:
    '6.1 用户不得无正当理由收取额外服务费用，或限制其他用户的付款方式（包括 BluePay 服务），亦不得为每笔交易设定最高或最低金额。',
  terms50:
    '6.2 用户不得通过提高交易价格来转嫁应支付的服务费用或相关支出给使用 BluePay 服务的其他用户，亦不得因任何原因增加使用 BluePay 服务的其他用户应支付的交易价格。如发生上述情形，用户应立即将额外费用退还给使用 BluePay 服务的其他用户。如果本公司调查发现用户对其他 BluePay 用户存在不平等待遇，用户应自行承担全部责任。如该等违规行为导致本公司遭受损失或损害，用户应赔偿本公司因此遭受的所有损害与损失。',
  terms51:
    '6.3 用户在任何情况下不得通过要求使用 BluePay 服务的其他用户放弃其提出争议或主张权利的权利，或放弃要求用户对因购买或使用商品与服务而导致的任何损害承担责任的权利。',
  title_terms7: '7. 协助调查',
  terms52:
    '7.1 本公司可要求用户提供有关任何交易的报告和/或信息，包括买卖协议的履行状态，以及本公司认为在调查用户使用服务时所必需的其他信息。用户不得拒绝此类报告和/或信息的请求。',
  terms53: '7.2 本公司可要求用户提供任何与遵守法律法规相关的必要信息和/或文件。用户应及时提供该等信息和/或文件。',
  title_terms8: '8. 服务费用',
  terms54:
    '8.1 作为本公司提供服务的回报，用户应支付本公司适用且不时通知用户的服务费用（以下简称“服务费用”）。服务费用的支付条款和条件在申请中列明。',
  terms55:
    '8.2 除非另有说明，用户根据本用户条款应支付给本公司的所有服务费用及其他款项不包括增值税、印花税和任何其他相关税费，除了支付此类服务费用或其他款项外，用户同意还需支付所有上述税费，包括罚金、附加费、罚款及任何政府费用。',
  terms56: '8.3 本公司可随时调整服务费用和/或新增费用，并应提前至少7天通知用户。',
  terms57:
    '8.4 如果用户未能在本条款规定的时间内支付本公司应付的款项，本公司保留单方面决定暂停任何服务的权利，且无需提前通知，或根据第15条终止本用户条款。',
  title_terms9: '9. 银行账户与付款程序',
  terms58:
    '9.1 用户应在本用户条款有效期内以及为履行本用户条款的任何相关条款的要求，始终维持一个本公司认可的银行账户，用于接收来自本公司的付款和向本公司付款（以下简称“用户银行账户”）。',
  terms59:
    '9.2 如果本公司能够直接从用户银行账户扣款，本公司有权根据本用户条款的规定，从用户银行账户直接扣除用户应支付的所有款项。本公司行使该权利时，不应影响其享有的任何其他权利或救济。用户应向其银行提交授权该等扣款的指令。',
  terms60:
    '9.3 用户应提前通知本公司其拟对用户银行账户进行的任何变更（包括但不限于账户开户行的变更）。此类变更仅在本公司确认后方可生效。',
  title_terms10: '10. 知识产权',
  terms61:
    '用户同意并确认，本用户条款中的任何内容均不构成授予用户任何与服务相关或包含于服务中的知识产权的权利、所有权或权益，所有此类权利均由本公司及其许可方保留。',
  title_terms11: '11. 保密条款',
  terms62: '11.1 就本条而言，“保密信息”指：',
  terms63: '11.1.1 本用户条款及其条款内容；',
  terms64: '11.1.2 与本公司相关的、其性质本身具有保密性的，或由本公司指定为保密的信息；',
  terms65: '11.1.3 与本公司相关的、用户已知或有理由知道或相信属于保密的信息；',
  terms66: '11.1.4 本公司向用户提供的任何个人数据；',
  terms67:
    '11.1.5 与本公司业务相关的信息，包括但不限于市场营销和推广计划、本公司的其他产品或资料、研究信息和分析、商业秘密、业务拓展和市场策略、销售数据、组织安排、业务计划、与他人的合同、客户名单、财务数据，及关于公司财务状况、资产或负债的相关信息；',
  terms68:
    '11.2 用户必须对本公司的保密信息予以保密，并且未经本公司事先书面同意，不得在任何时候将其用于本用户条款正当履行以外的任何目的，也不得向任何其他人披露，并且必须采取合理措施防止其未经授权的使用或披露。',
  terms69: '11.3 第11.2条的义务不适用于以下情况：',
  terms70: '11.3.1 任何已成为或随后成为公共领域的信息，且该情形并非因接收方行为或参与所致；',
  terms71: '11.3.2 任何接收方从无保密义务的第三方处获得的信息；',
  terms72:
    '11.3.3 任何在未接触或使用披露方保密信息的情况下，接收方在收到保密信息之前已独立开发的信息，并可通过接收方书面记录证明；',
  terms73:
    '11.3.4 根据适用法律要求披露的保密信息，但用户须首先取得本公司对披露形式与内容的书面批准，且披露范围应限于遵守该法律所必需的部分，并应采取合理措施确保信息接收方同意以与本条款相同的条件保密；',
  terms74: '11.3.5 根据具有管辖权的法院或仲裁机构的命令或指示，或因双方之间法律程序所必须披露的保密信息。',
  terms75:
    '11.4 用户承认并同意，违反本第11条的任何行为将对本公司造成无法弥补的损害，金钱赔偿不足以构成救济。因此，除可依法获得的其他救济或补偿外，对于实际或预期违反本条款的行为，本公司有权寻求衡平法上的救济（包括但不限于禁令、强制履行及其他衡平救济），无需提供任何形式的担保，且用户不得基于任何理由反对法院授予该等衡平救济。',
  terms76: '11.5 本第11条在本用户条款因任何原因终止、暂停或期满后仍然继续有效。',
  title_terms12: '12. 个人数据',
  terms77: '12.1 就本条而言：',
  terms78:
    '12.1.1 “个人数据”指有关特定个人的信息（无论其是否真实），只要该个人可通过该信息本身，或该信息与其他可由一方接触或可能接触的信息结合而被识别；',
  terms79:
    '12.1.2 “附加数据和权限”是指相机权限、上传照片权限和存储权限，以确保您可以使用诸如拍摄身份证照片之类的服务，访问您的照片存储以便您可以选择要使用的照片（例如在上传身份证件时），以及访问您设备的存储空间以确保您可以在创建或编辑照片后保存照片；',
  terms80: '12.1.3 “处理”个人数据，指：',
  terms81:
    '(a) 对个人数据进行任何操作或一系列操作，包括记录、持有、整理、调整/更改、检索、组合、传输或删除/销毁；和/或',
  terms82:
    '(b) 复制、使用、访问、展示、运行、存储、审阅、管理、修改、转换、翻译、提取组成部分形成其他作品、整合或并入衍生作品中；和/或',
  terms83: '(c) 允许他人执行上述 (a) 和/或 (b) 操作；',
  terms84: '12.2公司同意，如果用户向公司提供任何个人数据，无论是否与服务相关：',
  terms85:
    '12.2.1 公司应遵守所有与个人数据相关的适用法律法规，以及用户根据任何此类法律可能或将来可能要求公司遵守的任何相关法律法规所规定的要求；',
  terms86:
    '12.2.2 在不影响前述规定的普遍性的前提下，公司应确保其提供的个人数据保护标准与适用法律法规规定的保护标准相当，包括但不限于：',
  terms87: '(a) 目的：公司仅应严格按照用户提供该等个人数据的目的收集和使用该等个人数据，不得用于其他用途；',
  terms88:
    '(b) 使用和披露：公司仅应按照本用户条款允许的方式和范围使用和披露个人数据，并遵守所有关于该等使用或披露的限制；',
  terms89:
    '(c) 准确性：如果个人数据可能被公司用于 (i) 做出影响个人数据所涉个人的决定，则公司应尽合理努力确保个人数据的准确性和完整性；或 (ii) 公司向其他机构披露（但仅限于本用户条款允许的情况）；',
  terms90:
    '(d) 保护：公司应采取合理的安全措施保护其持有或控制的个人数据，以防止未经授权的访问、收集、使用、披露、复制、修改、处置或类似风险；',
  terms91:
    '(e) 保留：一旦有理由认为 (i) 保留个人数据不再用于特定目的；且 (ii) 出于法律或商业目的不再需要保留，公司应立即停止保留包含个人数据的文件，或移除将个人数据与特定个人关联的手段；',
  terms92: '(f) 境外传输：未经用户事先书面同意，公司不得将任何此类个人数据传输至泰国境外的任何地区。',
  terms93: '(g) 政策：公司应确保任何可能接收或访问任何个人数据的人员均知悉本条款规定的义务并同意遵守该等义务。',
  terms94:
    '12.3 如果用户发现任何个人数据的收集、使用或披露不符合本用户条款允许范围的情况，或任何个人数据的滥用，或任何与本用户条款相关的安全漏洞，导致个人数据的安全或完整性受到损害，或对用户造成不利影响，或使用户面临任何索赔、诉讼或法律程序，或者如果公司获悉或怀疑任何个人数据可能已被或可能已被任何未经授权的人员披露或获取，公司应立即通知用户，并与用户充分合作，在合理可行的范围内尽快解决问题，并充分配合用户进行的合理安全调查。',
  terms95:
    '12.4 公司同意并向用户承诺，无论用户向公司提供任何个人数据（无论是否与服务相关），公司均已遵守所有与此类个人数据相关的法律法规；',
  terms96:
    '公司已获得与该个人数据相关的每位个人的所有必要同意，允许公司披露该个人数据，并允许公司出于公司隐私政策中规定的目的收集、使用和披露该等个人数据。',
  title_terms13: '13. 争议',
  terms97:
    '13.1 用户应独自负责解决其与任何其他用户之间产生的所有争议或索赔，且不得将本公司牵涉其中。用户同意以与通过其他任何本用户可接受的支付方式进行的交易相同的方式处理所有关于在平台上交易的商品与服务并通过本服务支付的投诉。本公司不对任何此类争议或索赔承担责任或参与其中。',
  terms98:
    '13.2 如因用户使用服务产生任何性质的争议或索赔，应以用户和本公司所保存的详细交易文件和记录作为参考，并作为解决前述争议或索赔的唯一依据。若本公司与用户的记录存在差异，双方应根据各自掌握的信息共同调查差异，并在适当情况下作出必要的调整，但若差异无法调和，则以本公司的记录为准。',
  terms99:
    '13.3 用户同意，在任何交易中，如果由其他用户通过本服务或其他现有支付系统进行的支付超过应支付金额，用户应退还该多付的款项，并完全赔偿本公司因这些超额支付所引发的任何索赔。',
  title_terms14: '14. 保证/赔偿/责任',
  terms100:
    '14.1 用户同意为本公司、其母公司、子公司及关联公司，以及其高管、董事、代理人、合资企业、员工和供应商（“被赔偿方”）辩护、赔偿并使其免受任何索赔、要求、损害、费用或责任（包括但不限于合理的律师费用），这些索赔可能源自或与以下任何事项有关：',
  terms101: '14.1.1 用户或用户的员工或代理人违反本条款和/或政策；',
  terms102:
    '14.1.2 用户的客户、其他金融机构或其他第三方因平台上商品和服务销售的交易付款向本公司提出的任何索赔，无论是否之前已通过本公司提供的服务处理并转移给用户；',
  terms103: '14.1.3 由双方关系中的任何方面引发的任何其他索赔；',
  terms104: '14.1.4 本条款的执行或试图执行（包括回收或试图回收用户条款下应付本公司的任何款项）；',
  terms105: '14.1.5 本公司在保护其与用户关系中的利益时所产生的费用（包括本公司指定或指示的第三方费用）；',
  terms106: '14.1.6 在用户平台上完成的任何商品与服务交易（包括随后发现为欺诈交易的交易）；或',
  terms107: '14.1.7 用户与客户之间的任何其他安排，但在每种情况下，除非由本公司的疏忽或本公司违反用户条款所引起或导致。',
  terms108:
    '14.2 为避免疑义，如果本公司收到来自其客户、卡发行机构或任何其他第三方的索赔，本公司有权自行决定解决或以其他方式处理该索赔。',
  terms109: '14.3 如果用户为合伙企业，则每个合伙人应根据本用户条款共同并分别承担责任。',
  terms110:
    '14.4 服务按“现状”和“可用”提供。本公司及其被赔偿方不对 BluePay、服务及网站上的任何内容作出任何陈述、保证或承诺（无论是明示或暗示）。所有陈述、保证或承诺，包括但不限于准确性、可靠性、适销性、满意度、质量、特定用途适用性和非侵权等，均在法律允许的最大范围内被明确排除或免责声明。本公司保留修改、删除或部分修改服务的相关系统或功能的权利。',
  terms111:
    '14.5 在法律允许的最大范围内，本公司及其被赔偿方明确声明并排除任何和所有间接的、偶然的、特殊的、示范性的、后果性的、惩罚性的损失或损害（包括但不限于业务或商业机会、商誉、收入、利润、数据或其他经济利益的损失），这些损失或损害可能由用户（或任何通过用户提出索赔的人）因访问和/或使用服务/服务网站而遭受，无论这些损失或损害（a）是否发生在合同、侵权（包括疏忽）中；（b）该损失或损害是否可预见和/或（c）本公司是否已收到有关该损失或损害可能发生的通知：',
  terms112: '14.6 上述第14.5条中的免责声明和排除应适用法律允许的最大范围，但不适用于以下责任、损失或损害：',
  terms113: '14.6.1 由于本公司的疏忽导致的死亡或人身伤害；',
  terms114: '14.6.2 欺诈或虚假陈述；',
  terms115: '14.6.3 任何法律不允许排除的其他责任。',
  terms116:
    '14.7 本公司的总责任，无论是合同、侵权（包括疏忽）还是其他，无论是与本用户条款还是任何附属协议相关，应限于本公司在发生任何相关责任的前12个月内从用户收取的服务费用的总和。',
  title_terms15: '15. 条款和终止',
  terms117:
    '15.1 用户条款自用户提交服务申请或用户条款（视情况而定）之日起生效，并且在遵守第8.4条及15.2至15.3条（包括）的提前终止条款的情况下，继续有效，直到任何一方通过提前不少于一个完整日历月的书面通知终止该条款，前提是用户在自用户条款生效后的第一次交易日期起，至少经过12个月后，方可发出此类通知（为避免疑义，任何为了测试目的而进行的交易不计入此计算）。',
  terms118: '15.2 如果本公司书面通知用户未接受用户的服务申请，则用户条款应自收到该通知之日起立即终止。',
  terms119:
    '15.3 尽管有前述第15.1条，本公司有权在任何时候通过书面通知用户立即暂停全部或部分服务的提供，或终止用户条款或全部或部分服务，若发生以下任一情况：',
  terms120: '15.3.1 用户严重违反本用户条款的任何条款；',
  terms121: '15.3.2 用户未能按时支付本用户条款下的任何款项；',
  terms122: '15.3.3 本公司（自行决定）认为退款和/或冲正的总金额不合理；',
  terms123: '15.3.4 用户销售的商品和服务与其在申请阶段向本公司披露的内容有重大差异；',
  terms124: '15.3.5 用户进口、出口、销售或以其他方式从事任何禁止或有限制销售的商品与服务的交易；',
  terms125:
    '15.3.6 用户在其平台上向本公司提交的商品和服务交易中，未向相关的 BluePay 用户提供其应合理期望收到的商品、服务或其他设施；',
  terms126: '15.3.7 用户破产或已采取任何步骤进行清算、解散、破产、接管、管理或解散（或在任何司法管辖区发生类似情况）；',
  terms127: '15.3.8 用户与其债权人达成或提出任何安排；',
  terms128:
    '15.3.9 用户或任何事项被提交本公司，并且本公司自行认为该事项可能影响用户履行其在本用户条款下的义务或责任的能力或意愿；',
  terms129:
    '15.3.10 用户的情况发生任何变化（包括财务状况恶化或变化），或用户业务性质或用户向 BluePay 用户提供的商品与服务发生变化，本公司自行认为此变化对继续提供服务或本公司向用户提供的任何设施构成实质性影响；',
  terms130: '15.3.11 用户停止经营；',
  terms131: '15.3.12 本公司自行决定认为与用户的业务关系增加了本公司遭受损失或责任的风险；',
  terms132:
    '15.3.13 与用户相关的任何事项或事件发生，或与用户业务相关的任何事务（包括交易惯例和个人活动）出现问题，或用户从事任何本公司认为有损公司声誉、对公司业务不利、可能或已导致欺诈或其他刑事活动或怀疑欺诈的交易惯例或个人行为；',
  terms133:
    '15.3.14 用户控制权发生变化，无论是个人、公司、企业、未注册的协会（每个称为“个人”，合称“个人”），或根据协议或理解（无论正式或非正式）共同控制用户的个人或群体发生变化；',
  terms134: '15.3.15 用户或公司威胁或已启动与用户条款相关的任何索赔或诉讼；',
  terms135: '15.3.16 任何第三方提出针对本公司与用户的任何关系的索赔；',
  terms136:
    '15.3.17 本公司因任何信用卡公司（如 VISA 或 MasterCard 等）、信用卡发行机构、收单机构、其他银行或其他金融机构的要求被要求终止服务；',
  terms137: '15.3.18 用户从事本公司未同意的交易行为；',
  terms138: '15.3.19 本公司或其任何集团公司有权终止与用户或任何用户集团公司之间的任何协议。',
  title_terms16: '16. 终止的后果',
  terms139: '16.1 用户条款终止后，双方的所有权利和义务应立即终止，除非：',
  terms140: '16.1.1 本用户条款中明确或暗示在终止后仍然有效的条款，将继续具有执行力，尽管终止已发生；',
  terms141: '16.1.2 终止不应影响任何一方在终止日期之前根据本用户条款应享有的权利和义务。',
  terms142:
    '16.2 在用户条款终止时或终止后的任何时候，用户应立即支付本公司根据本用户条款所欠的所有款项，为避免疑义，本公司仍有权根据本条款扣留款项，并回收任何款项。',
  title_terms17: '17. 与其他条款和条件的关系',
  terms143: '17.1 除本用户条款外，用户使用服务还应遵守其他 BluePay 条款。',
  terms144:
    '17.2 除非相关条款另有规定，在本用户条款与其他 BluePay 条款之间存在任何不一致的情况下，应以本用户条款为准。',
  title_terms18: '18. 一般条款',
  terms145:
    '18.1 完整协议。除前述条款外，本用户条款构成双方就其所涉及事项达成的完整协议和理解，并取代和无效之前双方就本用户条款主题所做的所有其他口头或书面表述、安排、理解和协议。',
  terms146:
    '18.1.1 每一方保证其未依赖任何未在本用户条款中明确列出或提及的表述、安排、理解或协议（无论是书面还是口头）。任何一方对这些表述、安排、理解或协议的唯一救济将是依据本用户条款的违约责任。',
  terms147: '18.1.2 本条款18不应排除任何关于欺诈的责任。',
  terms148:
    '18.2 修改与变更。除非任何条款的修改、变更或任何一方的同意经书面形式且由另一方签署，否则无论如何都不会生效，且该等同意仅在特定情况下及特定目的下有效。尽管有前述规定，用户同意本公司有权随时通过书面或电子通知用户，提前不少于7天通知用户本用户条款的修改生效。',
  terms149: '18.3 可分割性。如果本用户条款的任何条款被任何具有管辖权的法院或行政机关认定为非法、无效或无法执行：',
  terms150: '18.3.1 该非法、无效或无法执行的条款不应影响本用户条款的其他条款，其他条款应继续有效；以及',
  terms151:
    '18.3.2 如果该条款通过对部分条款进行修改或删除可以变得合法、有效或可执行，则该条款应在最小的修改或删除后适用，以使其合法、有效和可执行。',
  terms152:
    '18.4 转让。本用户条款及本公司在其下的所有权利和义务可由本公司通过书面通知用户转让、转移、更新或以其他方式处理，且该转让将惠及本公司的继承人和受让人，用户应采取必要措施以便于该转让、转移、更新或处理。本用户条款及用户在条款下的所有权利和义务为个人专有，用户不得在未获得本公司事先书面同意的情况下，将这些权利和/或义务委托、转让、再许可或分包给任何第三方。',
  terms153: '18.5 通知。除非本条款另有规定，本公司向用户提供的任何通知应：',
  terms154:
    '18.5.1 以书面形式并使用英文语言，通过亲自递送、挂号邮寄并附回执、电子邮件或传真方式发送，并送达用户提供给本公司的最后地址或传真号码；并且',
  terms155:
    '18.5.2 应视为已收到，（a）在信函的情况下，亲自递交时视为送达，或在邮寄两（2）天后视为送达；（b）在电子邮件的情况下，视为在发送后的第一个工作日收到，前提是发送方未收到投递失败通知；（c）在传真情况下，视为在发送时收到，当接收方收到完整且清晰的复印件时即视为送达。',
  terms156: '18.6 不放弃。公司未及时行使其在本条款下的任何权利或部分权利，不应视为放弃该等权利。',
  terms157: '18.7 第三方权利。根据泰国《民法典》和《商法典》，非本用户条款的当事方无权根据本条款强制执行任何条款。',
  terms158:
    '18.8 翻译协议。任何本用户条款的翻译仅为用户提供方便，并不打算修改本用户条款的条文。如英语版用户条款与其他语言版本存在冲突，应以英语版本为准。',
  terms159:
    '18.9 管辖法律与管辖权。本用户条款的成立、解释、履行、有效性及其所有方面应受泰国法律和法规的管辖。双方在此不可撤销地同意将任何争议提交至公司所在地的泰国法院的专属管辖。',
  terms160: '18.10 修订日期。本条款的最新修订日期为2025年8月5日。'
}
